
import React from "react";
import AudioUpload from "./AudioUpload";
// import { CustomButton } from "../../../CustomButtom";
import ImageUpload from "./ImageUpload";
import { useEffect } from "react";
const type = [
  "text",
  "image",
  "audio",
  "underline"
]
const correctAnswerArray = [
  "option 1",
  "option 2",
  "option 3",
  "option 4"
]
const CustomButton = ({ setData, Data, DataValue, type, index, onChange }) => {
  return (
    <button className="border-0 bg-transparent" style={{ margin: "3px 0" }}
      onClick={() => {
        setData(DataValue)
        onChange(type, DataValue, index)

      }}
    >
      <div className={Data == DataValue ? "active-option" : "passive-option"}>
        <b>{DataValue}</b>
      </div>
    </button>
  )
}
const OptionView = ({
  type,
  Data,
  setData,
  placeholderValue,
  que,
  setDataText,
  DataText, type2, type3, index, onChange
}) => {
  return (
    <div>

      {(type == "text" || type == "underline") &&
        <>
          <textarea rows={3}
            className="p-0 px-2 col-12 input-common"
            value={Data}
            onChange={(event) => {
              setData(event.target.value)
              onChange(type2, event.target.value, index)
            }}
            placeholder={placeholderValue}
          />
        </>
      }
      {type == "underline" &&
        <input rows={1}
          className="input-common  p-0 px-2 col-12" style={{ width: "100%", margin: 0, marginTop: "3px" }}
          value={DataText}
          onChange={(event) => {
            setDataText(event.target.value)
            onChange(type3, event.target.value, index)
          }}
          placeholder={""}
        />
      }
      {
        type == "image" &&
        <>
          <ImageUpload
            ImageUrl={Data}
            setImageUrl={setData}
            onChange={onChange}
            type={type2}
            index={index}
          />
          <a style={{ color: "#000" }} href={Data} target="_blank">
            {Data.split("/")[Data.split("/").length - 1]}
          </a>
        </>
      }
      {
        type == "audio" &&
        <>
          <AudioUpload
            ImageUrl={Data}
            setImageUrl={setData}
            onChange={onChange}
            type={type2}
            index={index}
          />
          <a style={{ color: "#000" }} href={Data} target="_blank">
            {Data.split("/")[Data.split("/").length - 1]}

          </a>
        </>
      }
    </div>
  )
}
export default function ExamQuestionModal(props) {
  const {
    oneQuestionData,
    keyValue,
    AllQuestionData,
    setAllQuestionData,
    PostExam,
    setEditQuestion,
    setQuestionsEditMode,
    setQuestionsEditData,
    setQuestionsEditKey,
    ArrayIndex,
    setArrayIndex,
    onChangeFunction,
    EditInfo
  } = props;

  const [questionData, setQuestionData] = React.useState(oneQuestionData)
  const [questionNumber, setQuestionNumber] = React.useState(ArrayIndex+1)
  const [question, setQuestion] = React.useState(oneQuestionData.question)
  const [questionDescription, setQuestionDescription] = React.useState(oneQuestionData.question_description)
  const [questionBoxText, setQuestionBoxText] = React.useState(oneQuestionData.question_box_text)
  const [questionImage, setQuestionImage] = React.useState(oneQuestionData.question_image)
  const [questionAudio, setQuestionAudio] = React.useState(oneQuestionData.question_audio)
  const [questionDate, setQuestionsDate] = React.useState(oneQuestionData.question_date)
  const [option1, setOption1] = React.useState(oneQuestionData.option_1)
  const [option2, setOption2] = React.useState(oneQuestionData.option_2)
  const [option3, setOption3] = React.useState(oneQuestionData.option_3)
  const [option4, setOption4] = React.useState(oneQuestionData.option_4)
  const [option1Text, setOption1Text] = React.useState(oneQuestionData.option_1_text)
  const [option2Text, setOption2Text] = React.useState(oneQuestionData.option_2_text)
  const [option3Text, setOption3Text] = React.useState(oneQuestionData.option_3_text)
  const [option4Text, setOption4Text] = React.useState(oneQuestionData.option_4_text)
  const [answerDescription, setAnswerDescription] = React.useState(oneQuestionData.answer_description)
  const [correctAnswer, setCorrectAnswer] = React.useState(oneQuestionData.correct_answer)
  const [answerMediaType, setAnswerMediaType] = React.useState(oneQuestionData.answer_media_type)
  const [toastActive, setToastActive] = React.useState(false)
  const [toastText, setToastText] = React.useState("Enter Question")
  const [groupModal, setGroupModal] = React.useState(false)

  // useEffect(()=>{

  // },[])
  const Groups = [
    "다음 그림을 보고 맞는 단어나 문장을 고르십시오.",
    "다음 중 밑줄 친 부분이 맞는 것은 무엇입니까?",
    "다음 글을 읽고 물음에 답하십시오.",
    "빈칸에 들어갈 가장 알맞은 것을 고르십시오.",
    "다음 설명에 알맞은 어휘를 고르십시오.",
    "다음 글을 읽고 무엇에 대한 글인지 고르십시오. ",
    "다음 글을 읽고 내용과 같은 것을 고르십시오.",
    "들은 것을 고르십시오.",
    "다음을 듣고 들은 내용과 관계있는 그림을 고르십시오.",
    "다음을 듣고 질문에 알맞은 대답을 고르십시오.",
    "다음을 듣고 이어지는 말을 고르십시오.",
    "다음을 듣고 들은 내용과 관계있는 그림을 고르십시오.",
    "다음을 듣고 질문에 알맞은 대답을 고르십시오."
  ]
  const date = new Date()
  return (
    <div style={{ overflowX: "hidden" }}>
      <div>
        <div style={{ fontSize: "18px", marginBottom: "20px" }}><b>Add Question: </b></div>
      </div>
      <div style={{ color: "#d9d502", fontSize: "12px" }}>Modified: {questionDate}</div>
      <div className="row">
        <div className="col-6">
          Question Number :
          <input
            className="input-common"
            type="text"
            value={questionNumber}
            onChange={(event) => {
              setQuestionNumber(event.target.value)
              onChangeFunction("question_number", event.target.value, ArrayIndex)
            }}
            placeholder="Question"
            required
          />
        </div>
        <div className="col-6">
          Groups * :
          <div className="row">
            <div style={{ width: "100%" }}>
              <input
                className="input-common"
                value={question}
                onChange={(event) => {
                  setQuestion(event.target.value)
                  onChangeFunction("question", event.target.value, ArrayIndex)
                }}
                placeholder={"Enter Question Group or Select Group"}
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={() => { setGroupModal(true) }}>
              <div style={{ fontSize: "12px", borderRadius: "10px" }}>
                Or Select Group
              </div>
            </div>
            {groupModal &&
              <div className="modal"
                onClick={() => {
                  setGroupModal(false)
                }}
              >
                <div className="row">
                  <div className="col-sm-4" />
                  <div className="col-sm-4">
                    <div style={{ backgroundColor: "#fff", padding: "10px 0 0 " }}>
                      <div style={{ padding: "10px", textAlign: "center", borderBottom: "1px solid #999", fontWeight: "bold", fontSize: "20px" }}>
                        Groups
                      </div>
                      {Groups.map((item, index) => (
                        <div
                          onClick={() => {
                            setQuestion(item)
                            onChangeFunction("question", item, ArrayIndex)
                          }}
                          style={{ cursor: "pointer", padding: "5px 10px", borderBottom: "1px solid #999", textAlign: "center" }}
                          key={index} value={item} >{item}</div>
                      ))}
                    </div>
                    <div className="col-sm-4" />
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

      </div>
      <div style={{ fontSize: "16px" }}><b>Question: </b></div>
      <b>Title</b>
      <textarea rows={2}
        className="input-common"
        value={questionDescription}
        onChange={(event) => {
          setQuestionDescription(event.target.value)
          onChangeFunction("question_description", event.target.value, ArrayIndex)
        }}
        placeholder={"Enter Question"}
      />
      <b>Box Question</b>
      <textarea rows={3}
        className="input-common"
        value={questionBoxText}
        onChange={(event) => {
          setQuestionBoxText(event.target.value)
          onChangeFunction("question_box_text", event.target.value, ArrayIndex)
        }}
        placeholder={"Enter Question Box"}
      />

      <div className="row" style={{ marginBottom: "10px" }}>
        <div className="col-6">
          Question Image :
          <ImageUpload
            ImageUrl={questionImage}
            setImageUrl={setQuestionImage}
            onChange={onChangeFunction}
            type={"question_image"}
            index={ArrayIndex}
          />
          <a style={{ color: "#000" }} href={questionImage} target="_blank">
            {questionImage.split("/")[questionImage.split("/").length - 1]}
          </a>
        </div>
        <div className="col-6">
          Question Audio :
          <AudioUpload
            ImageUrl={questionAudio}
            setImageUrl={setQuestionAudio}
            onChange={onChangeFunction}
            type={"question_audio"}
            index={ArrayIndex}
          />
          <a style={{ color: "#000" }} href={questionAudio} target="_blank">
            {questionAudio.split("/")[questionAudio.split("/").length - 1]}

          </a>
        </div>
      </div>
      <div style={{ fontSize: "16px" }}><b>Answers: </b></div>
      <div style={{ display: "inline" }}>
        {type.map((item, index) => (
          <div style={{ display: "inline-block" }} key={index}>
            <CustomButton setData={setAnswerMediaType} Data={answerMediaType} DataValue={item}
              onChange={onChangeFunction}
              type={"answer_media_type"}
              index={ArrayIndex}
            />
          </div>
        ))}
      </div>

      <div className="row" >
        <div className="col-6">
          Option 1:
          <OptionView
            type={answerMediaType} que={false}
            Data={option1}
            setData={setOption1}
            placeholderValue={"Option 1"}
            DataText={option1Text}
            setDataText={setOption1Text}
            type2="option_1"
            type3="option_1_text"
            index={ArrayIndex} onChange={onChangeFunction}

          />
        </div>
        <div className="col-6">
          Option 2:
          <OptionView
            type={answerMediaType} que={false}
            Data={option2}
            setData={setOption2}
            placeholderValue={"Option 2"}
            DataText={option2Text}
            setDataText={setOption2Text}
            type2="option_2"
            type3="option_2_text"
            index={ArrayIndex} onChange={onChangeFunction}

          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "10px" }}>
        <div className="col-6">
          Option 3:
          <OptionView
            type={answerMediaType} que={false}
            Data={option3}
            setData={setOption3}
            placeholderValue={"Option 3"}
            DataText={option3Text}
            setDataText={setOption3Text}
            type2="option_3"
            type3="option_3_text"
            index={ArrayIndex} onChange={onChangeFunction}

          />
        </div>
        <div className="col-6">
          Option 4:
          <OptionView
            type={answerMediaType} que={false}
            Data={option4}
            setData={setOption4}
            placeholderValue={"Option 4"}
            DataText={option4Text}
            setDataText={setOption4Text}
            type2="option_4"
            type3="option_4_text"
            index={ArrayIndex} onChange={onChangeFunction}

          />
        </div>
      </div>
      <div>
        Correct Answer:
        <div style={{ display: "inline" }}>
          {correctAnswerArray.map((item, index) => (
            <div style={{ display: "inline-block" }} key={index}>
              {item !== "none" &&
                <CustomButton
                  setData={setCorrectAnswer} Data={correctAnswer} DataValue={item}
                  onChange={onChangeFunction}
                  type={"correct_answer"}
                  index={ArrayIndex}
                />
              }
            </div>
          ))}
        </div>
      </div>
      <b>Answer Description</b>
      <textarea rows={2}
        className="input-common"
        value={answerDescription}
        onChange={(event) => {
          setAnswerDescription(event.target.value)
          onChangeFunction("answer_description", event.target.value, ArrayIndex)
        }}
        placeholder={"Enter Answer Description"}
      />
      {/* {date.toDateString()} */}
      {/* {ArrayIndex}
      {Object.keys(AllQuestionData).length} */}
      <div className="row">
        <div style={{ display: "inline" }}>
          <div style={{ width: "30%", display: "inline-block", }}>
            {/* {ArrayIndex !== Object.keys(AllQuestionData).length - 1 &&
              <div className="sign-in-button-1"
                onClick={() => {
                  if (question !== "") {
                    setQuestionsEditMode(false)
                    setTimeout(() => {
                      EditInfo(false)
                      if (ArrayIndex !== Object.keys(AllQuestionData).length - 1) {
                        setQuestionsEditKey(Object.keys(AllQuestionData)[ArrayIndex + 1])
                        setQuestionsEditData(Object.values(AllQuestionData)[ArrayIndex + 1])
                        setQuestionsEditMode(true)
                        setArrayIndex(ArrayIndex + 1)
                      }
                    }, 200)
                  }
                  else
                    alert("Question Group Empty")
                }}
              >Update and Next
              </div>
            } */}
          </div>

          <div style={{ width: "30%", display: "inline-block", margin: "0 10px" }} className="sign-in-button-1"
            onClick={() => {
              if (question !== "") {
                // setAllQuestionData({
                //   ...AllQuestionData,
                //   [keyValue]: {
                //     "question_number": questionNumber,
                //     "question": question,
                //     "question_description": questionDescription,
                //     "question_date": date.toDateString(),
                //     "question_box_text": questionBoxText,
                //     "question_image": questionImage,
                //     "question_audio": questionAudio,
                //     "option_1": option1,
                //     "option_1_text": option1Text,
                //     "option_2": option2,
                //     "option_2_text": option2Text,
                //     "option_3": option3,
                //     "option_3_text": option3Text,
                //     "option_4": option4,
                //     "option_4_text": option4Text,
                //     "answer_description": answerDescription,
                //     "correct_answer": correctAnswer,
                //     "answer_media_type": answerMediaType,
                //   }
                // }
                // )
                EditInfo(false)
                setEditQuestion(false)
              }
              else
                alert("Question Group Empty")
            }
            }
          >Update</div>
          <div style={{ width: "30%", display: "inline-block", }} className="sign-in-button-1"
            onClick={() => {
              setQuestionsEditMode(false)
              oneQuestionData([])
              setQuestionsEditKey("")
            }}
          >Cancel
          </div>
        </div>
      </div>
    </div>
  )
}
